import React from 'react';
import ReactDOM from 'react-dom';

import {Provider} from 'react-redux'
import {applyMiddleware, createStore} from 'redux'
import Reducers from './reducers/Reducers';

import './assets/css/bootstrap-v4.1.3.min.css'
import 'antd/dist/antd.css'
import './assets/css/nice-select.css'
import './assets/css/style.css'
import './assets/css/responsive.css'
import './assets/css/custom.css'

import 'jquery/dist/jquery.min.js'
import 'popper.js/dist/popper.min'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'tiny-slider/dist/tiny-slider'
import 'jquery-countto/jquery.countTo'
import 'magnific-popup/dist/jquery.magnific-popup.min'
import 'jquery-circle-progress/dist/circle-progress.min'
import 'wow-singleton/index'
import 'isotope-layout/dist/isotope.pkgd.min'
import './utils/jquery.nice-select'
import './utils/JQueryUtil'
import "./i18n"

import App from './App'
import {composeWithDevTools} from 'redux-devtools-extension';
/*const store = createStore(Reducers, applyMiddleware(ReduxThunk));
*/
const store = createStore(Reducers, composeWithDevTools(
    applyMiddleware(),
    // other store enhancers if any
));

ReactDOM.render(<Provider store={store}><App/></Provider>, document.getElementById('root'))



